import { useEffect, useState } from "react";
import { ChartLine, House, Fire } from "@phosphor-icons/react";
import { DashboardLayout } from "../components/layout/DashboardLayout";
import { NotificationBell } from "../components/layout/NotificationBell";
import { RepSearchDropdown } from "../components/admin/RepSearchDropdown";
import { StoreOverviewCards } from "../components/admin/StoreOverviewCards";
import { CommissionTracker } from "../components/admin/CommissionTracker";
import { SubmissionsList } from "../components/admin/SubmissionsList";
import { StoreSettingsModal } from "../components/admin/StoreSettingsModal";
import { AdminReferrals } from "../components/admin/AdminReferrals";
import { api } from "../lib/api";
import { ECOMMERCE_MODULE_NAME } from "../constants/brand";

const navItems = [
  { to: "/admin/ecommerce", label: "Dashboard", icon: <House size={18} weight="duotone" />, testId: "nav-admin-dashboard" },
];

export default function AdminDashboardPage() {
  const [overview, setOverview] = useState(null);
  const [reports, setReports] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [settingsStore, setSettingsStore] = useState(null);

  const fetchAll = async () => {
    const [{ data: ov }, { data: reps }, { data: refs }] = await Promise.all([
      api.get("/admin/overview"),
      api.get("/admin/reports"),
      api.get("/admin/referrals"),
    ]);
    setOverview(ov);
    setReports(reps);
    setReferrals(refs);
  };

  useEffect(() => {
    fetchAll();
  }, []);

  if (!overview) {
    return (
      <div className="min-h-screen bg-igc-bg flex items-center justify-center">
        <ChartLine size={32} className="text-igc-goldText animate-pulse" />
      </div>
    );
  }

  return (
    <DashboardLayout navItems={navItems} topRight={<div className="flex items-center gap-3"><RepSearchDropdown /><NotificationBell /></div>} moduleName={ECOMMERCE_MODULE_NAME} moduleBackPath="/admin">
      <div data-testid="admin-dashboard">
        <h1 className="font-serif text-3xl text-igc-cream tracking-tight mb-8" title="Overview of every client e-commerce store IGC manages — revenue, ROI recovery, weekly submissions, and referrals.">{ECOMMERCE_MODULE_NAME}</h1>
        {overview.backoffice_streak_weeks > 0 && (
          <div className="flex items-center gap-2 mb-6 bg-igc-gold/10 border border-igc-gold/30 px-4 py-2.5 w-fit" data-testid="admin-backoffice-streak-badge" title="How many consecutive weeks Back Office has submitted client reports on time, with no late weeks.">
            <Fire size={18} weight="fill" className="text-igc-goldText" />
            <span className="text-igc-goldText text-sm font-medium">
              Adam — {overview.backoffice_streak_weeks}-week on-time streak
            </span>
          </div>
        )}
        <StoreOverviewCards stores={overview.stores} onEditSettings={setSettingsStore} />
        <CommissionTracker stores={overview.stores} totalCommission={overview.total_igc_commission} />
        <SubmissionsList reports={reports} onRefresh={fetchAll} />
        <AdminReferrals referrals={referrals} onRefresh={fetchAll} />
      </div>
      <StoreSettingsModal key={settingsStore?.client_id} store={settingsStore} open={!!settingsStore} onOpenChange={(v) => !v && setSettingsStore(null)} onSaved={fetchAll} />
    </DashboardLayout>
  );
}

